import axios from '../http'

function query(data) {
    return axios.post('/event/result/query', data);
}

function exportResult(data){
    const url =  "/event/result/exportResult";
    return axios.post(url, data, { responseType: 'blob' }).then((res) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(res);
        link.download = "Ranking By Event.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    })
}

function printResult(projectId) {
    const url = "/event/result/printResult?projectId="+projectId;
    return axios.get(url, { responseType: 'blob' }).then((res) => {
        const pdfUrl = window.URL.createObjectURL(new Blob([res], { type: 'application/pdf;charset=UTF-8'}));
        const newWindow = window.open(pdfUrl);
        window.URL.revokeObjectURL(newWindow);
    })
}

export default {
    query,
    exportResult,
    printResult
}